import http from '../api/http'

export default {
  addCashMovement: (cashMovement) => http.post('/cash-registers/add-cash-movement', cashMovement, { timeout: 30000 }),
  calculateReportTotals: (cashRegisterReportUuid) => http.get('/cash-registers/calculate-report-totals', { timeout: 30000, params: { cashRegisterReportUuid } }),
  closed: (cashRegisterReport) => http.post('/cash-registers/closed', cashRegisterReport),
  findByStoreId: (storeId) => http.get('/cash-registers/find-by-store-id', { params: { storeId } }),
  get: (identifier) => http.get('/cash-registers/get', { params: { identifier } }),
  getLastClosedReport: (identifier) => http.get('/cash-registers/get-last-closed-report', { params: { identifier } }),
  install: (identifier) => http.post('/cash-registers/install', { identifier }),
  opened: (identifier, reasonForOpening = 'automatic') => http.post('/cash-registers/opened', { identifier, reasonForOpening }),
  paginationReports: (conditions, pagination) => http.get('/cash-registers/pagination-reports', { params: { conditions, pagination } }),
  printedReport: (cashRegisterReportUuid) => http.post('/cash-registers/printed-report', { cashRegisterReportUuid }),
  started: (identifier, createdBalance = 0) => http.post('/cash-registers/start', { identifier, createdBalance }),
  saveEndpoint: (identifier, payload) => http.post('/cash-registers/save-endpoint', { identifier, payload })
}



// WEBPACK FOOTER //
// ./src/services/cash-registers.js